export default "__VITE_ASSET__Cs57vqiA__"